import Enumeration from '@/common/enumeration'

const Data = {
  GameGalacticWarrior: {
    ListHero: [
      {
        avatar: 'mermaid',
        name: 'Nữ thần biển cả'
      },
      {
        avatar: 'flower-queen',
        name: 'Nữ vương hoa'
      },
      {
        avatar: 'tech-god',
        name: 'Thần công nghệ'
      },
      {
        avatar: 'warrior-goddess',
        name: 'Nữ chiến binh'
      },
      {
        avatar: 'assassin',
        name: 'Siêu sát thủ'
      },
      {
        avatar: 'storm-god',
        name: 'Thần bão tố'
      },
      {
        avatar: 'lightning-god',
        name: 'Thần ánh sáng'
      },
      {
        avatar: 'speed-warrior',
        name: 'Chiến binh tốc độ'
      }
    ]
  },

  Combobox: {
    Month: [
      { Name: '', Value: 1 },
      { Name: '', Value: 2 },
      { Name: '', Value: 3 },
      { Name: '', Value: 4 },
      { Name: '', Value: 5 },
      { Name: '', Value: 6 },
      { Name: '', Value: 7 },
      { Name: '', Value: 8 },
      { Name: '', Value: 9 },
      { Name: '', Value: 10 },
      { Name: '', Value: 11 },
      { Name: '', Value: 12 }
    ]
  },

  Dashboard: {
    StatisticIndividual: [
      {
        Image: 'ic_commendation_board',
        Name: 'Bảng vinh danh'
      },
      {
        Image: 'ic_top_hardworking',
        Name: 'Học sinh chăm chỉ'
      },
      {
        Image: 'ic_submit_exercise',
        Name: 'Làm bài tập'
      },
      {
        Image: 'ic_rate_success',
        Name: 'Tỉ lệ làm đúng'
      },
      {
        Image: 'ic_subject_best',
        Name: 'Môn học tốt nhất'
      },
      {
        Image: 'ic_subject_keeptrying',
        Name: 'Môn học cần cố gắng'
      }
    ],

    ComboboxSubjectPrimary: [
      {
        SubjectCode: '',
        SubjectName: 'Tất cả các môn'
      },
      {
        SubjectCode: Enumeration.SubjectCode.TOAN,
        SubjectName: 'Toán'
      },
      {
        SubjectCode: Enumeration.SubjectCode.TIENGVIET,
        SubjectName: 'Tiếng Việt'
      },
      {
        SubjectCode: Enumeration.SubjectCode.TIENGANH,
        SubjectName: 'Tiếng Anh'
      }
    ],

    ComboboxSubject: [
      {
        SubjectCode: '',
        SubjectName: 'Tất cả các môn'
      },
      {
        SubjectCode: Enumeration.SubjectCode.TOAN,
        SubjectName: 'Toán'
      },
      {
        SubjectCode: Enumeration.SubjectCode.NGUVAN,
        SubjectName: 'Ngữ văn'
      },
      {
        SubjectCode: Enumeration.SubjectCode.TIENGANH,
        SubjectName: 'Tiếng Anh'
      },
      {
        SubjectCode: Enumeration.SubjectCode.VATLI,
        SubjectName: 'Vật lí'
      },
      {
        SubjectCode: Enumeration.SubjectCode.HOAHOC,
        SubjectName: 'Hóa học'
      },
      {
        SubjectCode: Enumeration.SubjectCode.SINHHOC,
        SubjectName: 'Sinh học'
      }
    ],

    RankWeek: [
      {
        Value: 1,
        Image: 'ic_cup_one'
      },
      {
        Value: 2,
        Image: 'ic_cup_two'
      },
      {
        Value: 3,
        Image: 'ic_cup_three'
      },
      {
        Value: 4,
        Image: 'ic_cup_four'
      },
      {
        Value: 5,
        Image: 'ic_cup_five'
      }
    ]
  },
  /**
   * giá học liệu Học Mãi
   * mapping với backend, nếu sửa cần sửa cả backend
   * giá trị ở đây chỉ dùng để hiển thị, giá trị thanh toán sẽ dựa vào tính toán trên backend
   */
  HocMaiCoursePrice: {
    PrimarySchool: 450000, // Học liệu tiểu học
    SecondarySchool: 450000, // Học liệu THCS
    HighSchool: 1050000, // Học liệu THPT
    ComboSecondarySchool: 1250000, // Combo học liệu THCS
    ComboHighSchool: 2550000// Combo học liệu THPT
  },

  SchoolExamPeriod: {
    // Phạm vi thi kiểm tra
    ListScope: [
      {
        Name: 'Toàn trường',
        Value: Enumeration.SchoolExamPeriodScope.School
      },
      {
        Name: 'Khối lớp',
        Value: Enumeration.SchoolExamPeriodScope.Grade
      },
      {
        Name: 'Lớp',
        Value: Enumeration.SchoolExamPeriodScope.Class
      },
      {
        Name: 'Học sinh',
        Value: Enumeration.SchoolExamPeriodScope.Student
      }
    ]
  },

  FrequentlyAskedQuestion: [
    {
      question: 'Học sinh đăng nhập và sử dụng EMIS Ôn tập như thế nào?',
      link: 'https://emishelp.misa.vn/kb/16472/'
    },
    {
      question: 'Học sinh quên mật khẩu thì làm thế nào?',
      link: 'https://emishelp.misa.vn/kb/20630/'
    },
    {
      question: 'Giáo viên có thể dùng phiếu bài tập có sẵn để giao cho các lớp không?',
      link: 'https://emishelp.misa.vn/kb/24117/'
    }
  ]
}
export default Data
